//
// This file has been generated by [index-modules](https://npmjs.com/index-modules)
//

const properties = {}

import _es, * as __es from "./es"
properties.es = { enumerable: true, get: () => _es }
export { __es as es }

import _fr, * as __fr from "./fr"
properties.fr = { enumerable: true, get: () => _fr }
export { __fr as fr }

import _he, * as __he from "./he"
properties.he = { enumerable: true, get: () => _he }
export { __he as he }

import _hu, * as __hu from "./hu"
properties.hu = { enumerable: true, get: () => _hu }
export { __hu as hu }

import _pl, * as __pl from "./pl"
properties.pl = { enumerable: true, get: () => _pl }
export { __pl as pl }

import _pt, * as __pt from "./pt"
properties.pt = { enumerable: true, get: () => _pt }
export { __pt as pt }

import _zh, * as __zh from "./zh"
properties.zh = { enumerable: true, get: () => _zh }
export { __zh as zh }

export default Object.create(null, properties)
